import { useState } from "react";
import { Navigate } from "react-router-dom";

import GreenFigure from "Assets/Common/green_figure.png";
import Logo from "Assets/Common/logo_footer.png";

import AdminRoutes from "Routes/Components/Admin";

import UseAuth from "Hooks/UseAuth";

import HeadRight from "Components/Common/Navigation/HeadRight";
import PageWrapper from "Components/Common/PageWrapper";
import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

const AuthLayout = ({ children, ...rest }) => {
  const { isAdmin } = UseAuth();
  const [open, setOpen] = useState(false);

  // if (!authorized)
  //   return (
  //     <Navigate
  //       to={isAdmin ? NoAuthRoutes.AdminLogin.path : NoAuthRoutes.Login.path}
  //       replace
  //     />
  //   );

  if (isAdmin) return <Navigate to={AdminRoutes.Dashboard.path} replace />;

  return (
    <S.MainGrid open={open} hasBgImg={rest.hasBgImg}>
      <HeadRight open={open} setOpen={setOpen} />

      <S.MainContainer open={open}>
        {rest.noWrapper ? (
          children
        ) : (
          <PageWrapper
            breadcrumb={{ currentRoute: rest?.name, parent: rest?.parent }}
          >
            {children}
          </PageWrapper>
        )}
      </S.MainContainer>

      {rest.greenFigure ? (
        <S.GreenFigure src={GreenFigure} alt="Green Figure" />
      ) : null}

      <S.Footer>
        <S.FooterContent>
          <S.Logo>
            <img src={Logo} alt="Logo" />
          </S.Logo>

          <S.Contact>
            <h2>Contato</h2>

            <p>
              Entre em contato através dos nossos canais de comunicação e
              cadastre-se para receber mais informações sobre a Sevenx.
            </p>

            <p>
              E-mail:{" "}
              <a
                href="mailto:contato@sevenxproducoesartisticas.com"
                target="_blank"
                rel="noreferrer"
              >
                contato@sevenxproducoesartisticas.com
              </a>
            </p>
          </S.Contact>

          <S.Socials>
            <S.Row>
              <GetIcon name="Whatsapp" />
              <a
                href="https://wa.me/5521972252311"
                target="_blank"
                rel="noreferrer"
              >
                +55 (21) 97225-2311
              </a>
            </S.Row>

            <S.Row>
              <GetIcon name="Instagram" />
              <a
                href="https://www.instagram.com/sevenxproducoesartisticas/"
                target="_blank"
                rel="noreferrer"
              >
                @sevenxproducoesartisticas
              </a>
            </S.Row>

            <S.Row>
              <GetIcon name="Twitter" />
              <a
                href="https://www.x.com/sevenxproducoes"
                target="_blank"
                rel="noreferrer"
              >
                @sevenxproducoes
              </a>
            </S.Row>
          </S.Socials>
        </S.FooterContent>
      </S.Footer>
    </S.MainGrid>
  );
};

export default AuthLayout;
